import { Component, Input } from '@angular/core';
import { environment } from '../../../../environments/environment';
@Component({
  selector: 'app-new-alert',
  templateUrl: './new-alert.component.html',
  styleUrl: './new-alert.component.scss',
})
export class NewAlertComponent {

  @Input() type: string;
  @Input() title: string;
  @Input() subTitle: string;
  @Input() customClass: string;

  protected readonly deployUrl = environment.deployUrl;
}
